import yolo_token from 'assets/coins/yolo_token.svg'
import usd_icon_circle from 'assets/coins/usd_icon.svg'

import usd_icon from 'assets/icons/usd_icon.svg'
import euro_icon from 'assets/icons/euro_icon.svg'

import btc_icon from 'assets/icons/bitcoin_icon.svg'
import btc_icon_png from 'assets/icons/btc_icon-100.png'

import eth_icon from 'assets/icons/eth_icon.svg'
import eth_icon_png from 'assets/icons/eth_icon-100.png'

import matic_icon from 'assets/icons/matic_icon.svg'
import matic_icon_png from 'assets/icons/matic_icon-100.png'

import doge_icon from 'assets/icons/doge_icon.svg'
import doge_icon_png from 'assets/icons/doge_icon-100.png'

import spy_icon from 'assets/icons/spy_icon.svg'
import spy_icon_png from 'assets/icons/spy_icon-100.png'

import tsla_icon from 'assets/icons/tesla_icon.svg'
import tsla_icon_png from 'assets/icons/tesla_icon-100.png'

import snap_icon from 'assets/icons/snap_icon.svg'
import snap_icon_png from 'assets/icons/snap_icon-100.png'

import aapl_icon from 'assets/icons/aapl_icon.svg'
import aapl_icon_png from 'assets/icons/aapl_icon-100.png'

import msft_icon from 'assets/icons/msft_icon.svg'
import msft_icon_png from 'assets/icons/msft_icon-100.png'

import amzn_icon from 'assets/icons/amzn_icon.svg'
import amzn_icon_png from 'assets/icons/amzn_icon-100.png'

import googl_icon from 'assets/icons/googl_icon.svg'
import googl_icon_png from 'assets/icons/googl_icon-100.png'

import meta_icon from 'assets/icons/meta_icon.svg'
import meta_icon_png from 'assets/icons/meta_icon-100.png'

import coin_icon from 'assets/icons/coin_icon.svg'
import coin_icon_png from 'assets/icons/coin_icon-100.png'

import sqqq_icon from 'assets/icons/sqqq_icon.svg'
import sqqq_icon_png from 'assets/icons/sqqq_icon-100.png'

import tqqq_icon from 'assets/icons/tqqq_icon.svg'
import tqqq_icon_png from 'assets/icons/tqqq_icon-100.png'

import vixm_icon from 'assets/icons/vixm_icon.svg'
import vixm_icon_png from 'assets/icons/vixm_icon-100.png'

import vixy_icon from 'assets/icons/vixy_icon.svg'
import vixy_icon_png from 'assets/icons/vixy_icon-100.png'

import sol_icon from 'assets/icons/solana_icon.svg'
import sol_icon_png from 'assets/icons/solana_icon-100.png'

import trx_icon from 'assets/icons/tron_icon.svg'
import trx_icon_png from 'assets/icons/tron_icon-100.png'

import nvda_icon from 'assets/icons/nvda_icon.svg'
import nvda_icon_png from 'assets/icons/nvda_icon-100.png'

import slv_icon from 'assets/icons/slv_icon.svg'
import slv_icon_png from 'assets/icons/slv_icon-100.png'

import bbby_icon from 'assets/icons/bbby_icon.svg'
import bbby_icon_png from 'assets/icons/bbby_icon-100.png'

import eem_icon from 'assets/icons/eem_icon.svg'
import eem_icon_png from 'assets/icons/eem_icon-100.png'

import efa_icon from 'assets/icons/efa_icon.svg'
import efa_icon_png from 'assets/icons/efa_icon-100.png'

import fxi_icon from 'assets/icons/fxi_icon.svg'
import fxi_icon_png from 'assets/icons/fxi_icon-100.png'

import gdx_icon from 'assets/icons/gdx_icon.svg'
import gdx_icon_png from 'assets/icons/gdx_icon-100.png'

import hyg_icon from 'assets/icons/hyg_icon.svg'
import hyg_icon_png from 'assets/icons/hyg_icon-100.png'

import iwm_icon from 'assets/icons/iwm_icon.svg'
import iwm_icon_png from 'assets/icons/iwm_icon-100.png'

import labu_icon from 'assets/icons/labu_icon.svg'
import labu_icon_png from 'assets/icons/labu_icon-100.png'

import lqd_icon from 'assets/icons/lqd_icon.svg'
import lqd_icon_png from 'assets/icons/lqd_icon-100.png'

import sh_icon from 'assets/icons/sh_icon.svg'
import sh_icon_png from 'assets/icons/sh_icon-100.png'

import soxl_icon from 'assets/icons/soxl_icon.svg'
import soxl_icon_png from 'assets/icons/soxl_icon-100.png'

import spxs_icon from 'assets/icons/spxs_icon.svg'
import spxs_icon_png from 'assets/icons/spxs_icon-100.png'

import spxu_icon from 'assets/icons/spxu_icon.svg'
import spxu_icon_png from 'assets/icons/spxu_icon-100.png'

import tlt_icon from 'assets/icons/tlt_icon.svg'
import tlt_icon_png from 'assets/icons/tlt_icon-100.png'

import vea_icon from 'assets/icons/vea_icon.svg'
import vea_icon_png from 'assets/icons/vea_icon-100.png'

import xle_icon from 'assets/icons/xle_icon.svg'
import xle_icon_png from 'assets/icons/xle_icon-100.png'

import xlf_icon from 'assets/icons/xlf_icon.svg'
import xlf_icon_png from 'assets/icons/xlf_icon-100.png'

import ltc_icon from 'assets/icons/ltc_icon.svg'
import ltc_icon_png from 'assets/icons/ltc_icon-100.png'

import xrp_icon from 'assets/icons/xrp_icon.svg'
import xrp_icon_png from 'assets/icons/xrp_icon-100.png'

import link_icon from 'assets/icons/link_icon.svg'
import link_icon_png from 'assets/icons/link_icon-100.png'

import ada_icon from 'assets/icons/ada_icon.svg'
import ada_icon_png from 'assets/icons/ada_icon-100.png'

import dot_icon from 'assets/icons/dot_icon.svg'
import dot_icon_png from 'assets/icons/dot_icon-100.png'

import ape_icon from 'assets/icons/ape_icon.svg'
import ape_icon_png from 'assets/icons/ape_icon-100.png'

import dis_icon from 'assets/icons/dis_icon.svg'
import dis_icon_png from 'assets/icons/dis_icon-100.png'

import hood_icon from 'assets/icons/hood_icon.svg'
import hood_icon_png from 'assets/icons/hood_icon-100.png'

import pypl_icon from 'assets/icons/pypl_icon.svg'
import pypl_icon_png from 'assets/icons/pypl_icon-100.jpg'

import dkng_icon from 'assets/icons/dkng_icon.svg'
import dkng_icon_png from 'assets/icons/dkng_icon-100.png'

import uber_icon from 'assets/icons/uber_icon.svg'
import uber_icon_png from 'assets/icons/uber_icon-100.png'

import baba_icon from 'assets/icons/baba_icon.svg'
import baba_icon_png from 'assets/icons/baba_icon-100.png'

import pltr_icon from 'assets/icons/pltr_icon.svg'
import pltr_icon_png from 'assets/icons/pltr_icon-100.png'

import rlb_icon from 'assets/icons/rlb_icon.svg'
import rlb_icon_png from 'assets/icons/rlb_icon-100.png'

import amc_icon from 'assets/icons/amc_icon.svg'
import amc_icon_png from 'assets/icons/amc_icon-100.png'

import gme_icon from 'assets/icons/gme_icon.svg'
import gme_icon_png from 'assets/icons/gme_icon-100.png'

import dydx_icon from 'assets/icons/dydx_icon.svg'
import dydx_icon_png from 'assets/icons/dydx_icon-100.png'

import tgt_icon from 'assets/icons/tgt_icon.svg'
import tgt_icon_png from 'assets/icons/tgt_icon-100.png'

import nflx_icon from 'assets/icons/nflx_icon.svg'
import nflx_icon_png from 'assets/icons/nflx_icon-100.png'

import jpm_icon from 'assets/icons/jpm_icon.svg'
import jpm_icon_png from 'assets/icons/jpm_icon-100.png'

import gs_icon from 'assets/icons/gs_icon.svg'
import gs_icon_png from 'assets/icons/gs_icon-100.png'

import bac_icon from 'assets/icons/bac_icon.svg'
import bac_icon_png from 'assets/icons/bac_icon-100.png'

import wfc_icon from 'assets/icons/wfc_icon.svg'
import wfc_icon_png from 'assets/icons/wfc_icon-100.png'

import c_icon from 'assets/icons/c_icon.svg'
import c_icon_png from 'assets/icons/c_icon-100.png'

import ms_icon from 'assets/icons/ms_icon.svg'
import ms_icon_png from 'assets/icons/ms_icon-100.png'

import cof_icon from 'assets/icons/cof_icon.svg'
import cof_icon_png from 'assets/icons/cof_icon-100.png'

import si_icon from 'assets/icons/si_icon.svg'
import si_icon_png from 'assets/icons/si_icon-100.png'

import usdc_icon from 'assets/icons/usdc_icon.svg'
import usdc_icon_png from 'assets/icons/usdc_icon-100.png'

import frc_icon from 'assets/icons/frc_icon.svg'
import frc_icon_png from 'assets/icons/frc_icon-100.png'

import cs_icon from 'assets/icons/cs_icon.svg'
import cs_icon_png from 'assets/icons/cs_icon-100.png'

import nke_icon from 'assets/icons/nke_icon.svg'
import nke_icon_png from 'assets/icons/nke_icon-100.png'

import bs_icon from 'assets/icons/bs_icon.svg'
import bs_icon_png from 'assets/icons/bs_icon-100.png'

import arb_icon from 'assets/icons/arb_icon.svg'
import arb_icon_png from 'assets/icons/arb_icon-100.png'

import fcnca_icon from 'assets/icons/fcnca_icon.svg'
import fcnca_icon_png from 'assets/icons/fcnca_icon-100.png'

import bnb_icon from 'assets/icons/bnb_icon.svg'
import bnb_icon_png from 'assets/icons/bnb_icon-100.png'

import zm_icon from 'assets/coins/zm_icon.svg'
import zm_icon_png from 'assets/coins/zm_icon-100.jpg'

import ihodl_icon from 'assets/icons/ihodl_icon.png'
import ihodl_icon_png from 'assets/icons/ihodl_icon.png'

import ishit_icon from 'assets/icons/ishit_icon.png'
import ishit_icon_png from 'assets/icons/ishit_icon.png'

import avax_icon from 'assets/icons/avax_icon.svg'
import avax_icon_png from 'assets/icons/avax_icon-100.png'

import grt_icon from 'assets/icons/grt_icon.svg'
import grt_icon_png from 'assets/icons/grt_icon-100.png'

import apt_icon from 'assets/icons/apt_icon.svg'
import apt_icon_png from 'assets/icons/apt_icon-100.png'

import ctsi_icon from 'assets/icons/ctsi_icon.svg'
import ctsi_icon_png from 'assets/icons/ctsi_icon-100.png'

import bit_icon from 'assets/icons/bit_icon.svg'
import bit_icon_png from 'assets/icons/bit_icon-100.png'

import crv_icon from 'assets/icons/crv_icon-100.png'
import crv_icon_png from 'assets/icons/crv_icon-100.png'

import op_icon from 'assets/icons/op_icon.svg'
import op_icon_png from 'assets/icons/op_icon-100.png'

import mkr_icon from 'assets/icons/mkr_icon.svg'
import mkr_icon_png from 'assets/icons/mkr_icon-100.png'

import gmx_icon from 'assets/icons/gmx_icon.svg'
import gmx_icon_png from 'assets/icons/gmx_icon-100.png'

import snx_icon from 'assets/icons/snx_icon.svg'
import snx_icon_png from 'assets/icons/snx_icon-100.png'

import zec_icon from 'assets/icons/zec_icon.svg'
import zec_icon_png from 'assets/icons/zec_icon-100.png'

import oneInch_icon from 'assets/icons/1inch_icon.svg'
import oneInch_icon_png from 'assets/icons/1inch_icon-100.png'

import ftt_icon from 'assets/icons/ftt_icon.svg'
import ftt_icon_png from 'assets/icons/ftt_icon-100.png'

import sushi_icon from 'assets/icons/sushi_icon.svg'
import sushi_icon_png from 'assets/icons/sushi_icon-100.png'

import dash_icon from 'assets/icons/dash_icon.svg'
import dash_icon_png from 'assets/icons/dash_icon-100.png'

import zrx_icon from 'assets/icons/zrx_icon.svg'
import zrx_icon_png from 'assets/icons/zrx_icon-100.png'

import band_icon from 'assets/icons/band_icon.svg'
import band_icon_png from 'assets/icons/band_icon-100.png'

import ens_icon from 'assets/icons/ens_icon.svg'
import ens_icon_png from 'assets/icons/ens_icon-100.png'

import pepe_icon from 'assets/icons/pepe_icon-100.png'
import pepe_icon_png from 'assets/icons/pepe_icon-100.png'

import wojak_icon from 'assets/icons/wojak_icon-100.png'
import wojak_icon_png from 'assets/icons/wojak_icon-100.png'

import dino_icon from 'assets/icons/dino_icon-100.png'
import dino_icon_png from 'assets/icons/dino_icon-100.png'

import alameda_icon from 'assets/icons/alameda_icon-100.png'
import alameda_icon_png from 'assets/icons/alameda_icon-100.png'

import layer2_icon from 'assets/icons/layer2_icon-100.png'
import layer2_icon_png from 'assets/icons/layer2_icon-100.png'

import liqme_icon from 'assets/icons/liqme_icon-100.png'
import liqme_icon_png from 'assets/icons/liqme_icon-100.png'

import swap_icon from 'assets/icons/swap_icon-100.png'
import swap_icon_png from 'assets/icons/swap_icon-100.png'

import dgov_icon from 'assets/icons/dgov_icon-100.png'
import dgov_icon_png from 'assets/icons/dgov_icon-100.png'

import aave_icon from 'assets/icons/aave_icon.svg'
import aave_icon_png from 'assets/icons/aave_icon-100.png'

import comp_icon from 'assets/icons/comp_icon.svg'
import comp_icon_png from 'assets/icons/comp_icon-100.png'

import uni_icon from 'assets/icons/uni_icon.svg'
import uni_icon_png from 'assets/icons/uni_icon-100.png'

import ftm_icon from 'assets/icons/ftm_icon.svg'
import ftm_icon_png from 'assets/icons/ftm_icon-100.png'

import floki_icon from 'assets/icons/floki_icon.svg'
import floki_icon_png from 'assets/icons/floki_icon-100.png'

import yolocoaster_icon from 'assets/icons/yolocoaster_icon.svg'
import yolocoaster_icon_png from 'assets/icons/yolocoaster_icon-100.png'

import blur_icon from 'assets/icons/blur_icon.svg'
import blur_icon_png from 'assets/icons/blur_icon-100.png'

import mong_icon from 'assets/icons/mong_icon.png'
import mong_icon_png from 'assets/icons/mong_icon.png'

import ladys_icon from 'assets/icons/ladys_icon.png'
import ladys_icon_png from 'assets/icons/ladys_icon-100.png'

import kda_icon from 'assets/icons/kda_icon.svg'
import kda_icon_png from 'assets/icons/kda_icon-100.png'

import inj_icon from 'assets/icons/inj_icon.svg'
import inj_icon_png from 'assets/icons/inj_icon-100.png'

import rndr_icon from 'assets/icons/rndr_icon.svg'
import rndr_icon_png from 'assets/icons/rndr_icon-100.png'

import tslarekt_icon from 'assets/icons/tslarekt_icon.svg'
import tslarekt_icon_png from 'assets/icons/tslarekt_icon-100.png'

import yolospy_icon from 'assets/icons/yolospy_icon.svg'
import yolospy_icon_png from 'assets/icons/yolospy_icon-100.png'

import amznrox_icon from 'assets/icons/amznrox_icon.svg'
import amznrox_icon_png from 'assets/icons/amznrox_icon-100.png'

import googlwhale_icon from 'assets/icons/googlwhale_icon.svg'
import googlwhale_icon_png from 'assets/icons/googlwhale_icon-100.png'

import aaplballer_icon from 'assets/icons/aaplballer_icon.svg'
import aaplballer_icon_png from 'assets/icons/aaplballer_icon-100.png'

import lina_icon from 'assets/icons/lina_icon.svg'
import lina_icon_png from 'assets/icons/lina_icon-100.png'

import axs_icon from 'assets/icons/axs_icon.svg'
import axs_icon_png from 'assets/icons/axs_icon-100.png'

import mana_icon from 'assets/icons/mana_icon.svg'
import mana_icon_png from 'assets/icons/mana_icon-100.png'

import sand_icon from 'assets/icons/sand_icon.svg'
import sand_icon_png from 'assets/icons/sand_icon-100.png'

import kmx_icon from 'assets/icons/kmx_icon.svg'
import kmx_icon_png from 'assets/icons/kmx_icon-100.png'

import docu_icon from 'assets/icons/docu_icon.svg'
import docu_icon_png from 'assets/icons/docu_icon-100.png'

import manu_icon from 'assets/icons/manu_icon.svg'
import manu_icon_png from 'assets/icons/manu_icon-100.png'

import ai_icon from 'assets/icons/ai_icon.svg'
import ai_icon_png from 'assets/icons/ai_icon-100.png'

//----- coins --------
import usdt_icon from 'assets/coins/usdt_icon.svg'
import usdt_icon_png from 'assets/coins/usdt_icon-100.png'

import nio_icon from 'assets/coins/nio_icon.svg'
import nio_icon_png from 'assets/coins/nio_icon-100.png'

import cvna_icon from 'assets/coins/cvna_icon.svg'
import cvna_icon_png from 'assets/coins/cvna_icon-100.png'

import afrm_icon from 'assets/coins/afrm_icon.svg'
import afrm_icon_png from 'assets/coins/afrm_icon-100.png'

import sofi_icon from 'assets/coins/sofi_icon.svg'
import sofi_icon_png from 'assets/coins/sofi_icon-100.png'

import amd_icon from 'assets/coins/amd_icon.svg'
import amd_icon_png from 'assets/coins/amd_icon-100.png'

import pld_icon from 'assets/coins/pld_icon.svg'
import pld_icon_png from 'assets/coins/pld_icon-100.png'

import eqix_icon from 'assets/coins/eqix_icon.svg'
import eqix_icon_png from 'assets/coins/eqix_icon-100.png'

import amt_icon from 'assets/coins/amt_icon.svg'
import amt_icon_png from 'assets/coins/amt_icon-100.png'

import bch_icon from 'assets/coins/bch_icon.svg'
import bch_icon_png from 'assets/coins/bch_icon-100.png'

import autogpt_icon from 'assets/coins/autogpt_icon.png'
import autogpt_icon_png from 'assets/coins/autogpt_icon-100.png'

import wld_icon from 'assets/coins/wld_icon.svg'
import wld_icon_png from 'assets/coins/wld_icon-100.png'

import xom_icon from 'assets/coins/xom_icon.svg'
import xom_icon_png from 'assets/coins/xom_icon-100.png'

import pg_icon from 'assets/coins/pg_icon.svg'
import pg_icon_png from 'assets/coins/pg_icon-100.png'

import unibot_icon from 'assets/coins/unibot_icon.png'
import unibot_icon_png from 'assets/coins/unibot_icon-100.png'

import friend_tech_icon from 'assets/coins/friend_tech_icon.png'
import friend_tech_icon_png from 'assets/coins/friend_tech_icon-100.png'

import cart_icon from 'assets/coins/cart_icon.svg'
import cart_icon_png from 'assets/coins/cart_icon-100.png'

import tia_icon from 'assets/coins/tia_icon.svg'
import tia_icon_png from 'assets/coins/tia_icon.svg'

import pyth_icon from 'assets/coins/pyth_icon.svg'
import pyth_icon_png from 'assets/coins/pyth_icon.svg'

import bonk_icon from 'assets/coins/bonk_icon.svg'
import bonk_icon_png from 'assets/coins/bonk_icon.svg'

import meme_icon from 'assets/coins/meme_icon.png'
import meme_icon_png from 'assets/coins/meme_icon.png'

import gas_icon from 'assets/coins/gas_icon.svg'
import gas_icon_png from 'assets/coins/gas_icon.svg'

import wif_icon from 'assets/coins/wif_icon.png'
import wif_icon_png from 'assets/coins/wif_icon.png'

import sei_icon from 'assets/coins/sei_icon.svg'
import sei_icon_png from 'assets/coins/sei_icon-100.png'

import cyber_icon from 'assets/coins/cyber_icon.svg'
import cyber_icon_png from 'assets/coins/cyber_icon-100.png'

import sui_icon from 'assets/coins/sui_icon.svg'
import sui_icon_png from 'assets/coins/sui_icon-100.png'

import imx_icon from 'assets/coins/imx_icon.svg'
import imx_icon_png from 'assets/coins/imx_icon-100.png'

import pendle_icon from 'assets/coins/pendle_icon.svg'
import pendle_icon_png from 'assets/coins/pendle_icon-100.png'

import ondo_icon from 'assets/coins/ondo_icon.svg'
import ondo_icon_png from 'assets/coins/ondo_icon-100.png'

import manta_icon from 'assets/coins/manta_icon.svg'
import manta_icon_png from 'assets/coins/manta_icon-100.png'

import cfx_icon from 'assets/coins/cfx_icon.svg'
import cfx_icon_png from 'assets/coins/cfx_icon-100.png'

import jup_icon from 'assets/coins/jup_icon.svg'
import jup_icon_png from 'assets/coins/jup_icon-100.png'

import near_icon from 'assets/coins/near_icon.svg'
import near_icon_png from 'assets/coins/near_icon-100.png'

import tao_icon from 'assets/coins/tao_icon.png'
import tao_icon_png from 'assets/coins/tao_icon-100.png'

import pork_icon from 'assets/coins/pork_icon.png'
import pork_icon_png from 'assets/coins/pork_icon-100.png'

import dym_icon from 'assets/coins/dym_icon.svg'
import dym_icon_png from 'assets/coins/dym_icon-100.png'

import zeta_icon from 'assets/coins/zeta_icon.svg'
import zeta_icon_png from 'assets/coins/zeta_icon-100.png'

import atom_icon from 'assets/coins/atom_icon.svg'
import atom_icon_png from 'assets/coins/atom_icon-100.png'

import ntrn_icon from 'assets/coins/ntrn_icon.svg'
import ntrn_icon_png from 'assets/coins/ntrn_icon-100.png'

import fet_icon from 'assets/coins/fet_icon.svg'
import fet_icon_png from 'assets/coins/fet_icon-100.png'

import agix_icon from 'assets/coins/agix_icon.svg'
import agix_icon_png from 'assets/coins/agix_icon-100.png'

import bome_icon from 'assets/coins/crypto_icon-generic.svg'
import bome_icon_png from 'assets/coins/crypto_icon-generic.svg'

import vanry_icon from 'assets/coins/crypto_icon-generic.svg'
import vanry_icon_png from 'assets/coins/crypto_icon-generic.svg'

import fil_icon from 'assets/coins/crypto_icon-generic.svg'
import fil_icon_png from 'assets/coins/crypto_icon-generic.svg'

import portal_icon from 'assets/coins/crypto_icon-generic.svg'
import portal_icon_png from 'assets/coins/crypto_icon-generic.svg'

import jasmy_icon from 'assets/coins/crypto_icon-generic.svg'
import jasmy_icon_png from 'assets/coins/crypto_icon-generic.svg'

// import bome_icon from 'assets/coins/bome_icon.svg'
// import bome_icon_png from 'assets/coins/bome_icon-100.png'

// import vanry_icon from 'assets/coins/vanry_icon.svg'
// import vanry_icon_png from 'assets/coins/vanry_icon-100.png'

// import fil_icon from 'assets/coins/fil_icon.svg'
// import fil_icon_png from 'assets/coins/fil_icon-100.png'

// import portal_icon from 'assets/coins/portal_icon.svg'
// import portal_icon_png from 'assets/coins/portal_icon-100.png'

// import jasmy_icon from 'assets/coins/jasmy_icon.svg'
// import jasmy_icon_png from 'assets/coins/jasmy_icon-100.png'

export const assets = {
  yolo_token,
  usd_icon_circle,
  usd_icon,
  euro_icon,

  eth_icon,
  matic_icon,

  spy_icon,
  tsla_icon,
  snap_icon,
  aapl_icon,
  msft_icon,
  amzn_icon,
  googl_icon,
  meta_icon,
  coin_icon,
  sqqq_icon,
  tqqq_icon,
  vixm_icon,
  vixy_icon,
  slv_icon,
  bbby_icon,
  eem_icon,
  efa_icon,
  fxi_icon,
  gdx_icon,
  hyg_icon,
  iwm_icon,
  labu_icon,
  lqd_icon,
  sh_icon,
  soxl_icon,
  spxs_icon,
  spxu_icon,
  tlt_icon,
  vea_icon,
  xle_icon,
  xlf_icon,
  ltc_icon,
  xrp_icon,
  link_icon,
  ada_icon,
  dot_icon,
  ape_icon,
  btc_icon,
  doge_icon,
  sol_icon,
  trx_icon,
  nvda_icon,
  dis_icon,
  hood_icon,
  pypl_icon,
  zm_icon,
  dkng_icon,
  uber_icon,
  baba_icon,
  pltr_icon,
  rlb_icon,
  amc_icon,
  gme_icon,
  dydx_icon,
  tgt_icon,
  nflx_icon,
  jpm_icon,
  gs_icon,
  bac_icon,
  wfc_icon,
  c_icon,
  ms_icon,
  cof_icon,
  si_icon,
  usdc_icon,
  frc_icon,
  cs_icon,
  nke_icon,
  bs_icon,
  arb_icon,
  fcnca_icon,
  bnb_icon,

  xlf_icon_png,
  bbby_icon_png,
  eem_icon_png,
  efa_icon_png,
  fxi_icon_png,
  gdx_icon_png,
  hyg_icon_png,
  iwm_icon_png,
  labu_icon_png,
  lqd_icon_png,
  sh_icon_png,
  slv_icon_png,
  soxl_icon_png,
  spxs_icon_png,
  spxu_icon_png,
  tlt_icon_png,
  vea_icon_png,
  xle_icon_png,
  btc_icon_png,
  eth_icon_png,
  matic_icon_png,
  doge_icon_png,
  spy_icon_png,
  tsla_icon_png,
  snap_icon_png,
  aapl_icon_png,
  msft_icon_png,
  amzn_icon_png,
  googl_icon_png,
  meta_icon_png,
  coin_icon_png,
  sqqq_icon_png,
  tqqq_icon_png,
  vixm_icon_png,
  vixy_icon_png,
  sol_icon_png,
  trx_icon_png,
  nvda_icon_png,
  ltc_icon_png,
  xrp_icon_png,
  link_icon_png,
  ada_icon_png,
  dot_icon_png,
  ape_icon_png,
  dis_icon_png,
  hood_icon_png,
  pypl_icon_png,
  zm_icon_png,
  dkng_icon_png,
  uber_icon_png,
  baba_icon_png,
  pltr_icon_png,
  rlb_icon_png,
  amc_icon_png,
  gme_icon_png,
  dydx_icon_png,
  tgt_icon_png,
  nflx_icon_png,
  jpm_icon_png,
  gs_icon_png,
  bac_icon_png,
  wfc_icon_png,
  c_icon_png,
  ms_icon_png,
  cof_icon_png,
  si_icon_png,
  usdc_icon_png,
  frc_icon_png,
  cs_icon_png,
  nke_icon_png,
  bs_icon_png,
  arb_icon_png,
  fcnca_icon_png,
  bnb_icon_png,

  ihodl_icon,
  ihodl_icon_png,

  ishit_icon,
  ishit_icon_png,

  avax_icon,
  avax_icon_png,

  grt_icon,
  grt_icon_png,

  apt_icon,
  apt_icon_png,

  ctsi_icon,
  ctsi_icon_png,

  bit_icon,
  bit_icon_png,

  crv_icon,
  crv_icon_png,

  op_icon,
  op_icon_png,

  mkr_icon,
  mkr_icon_png,

  gmx_icon,
  gmx_icon_png,

  snx_icon,
  snx_icon_png,

  zec_icon,
  zec_icon_png,

  oneInch_icon,
  oneInch_icon_png,

  ftt_icon,
  ftt_icon_png,

  sushi_icon,
  sushi_icon_png,

  dash_icon,
  dash_icon_png,

  zrx_icon,
  zrx_icon_png,

  band_icon,
  band_icon_png,

  ens_icon,
  ens_icon_png,

  pepe_icon,
  pepe_icon_png,

  wojak_icon,
  wojak_icon_png,

  dino_icon,
  dino_icon_png,

  alameda_icon,
  alameda_icon_png,

  layer2_icon,
  layer2_icon_png,

  liqme_icon,
  liqme_icon_png,

  swap_icon,
  swap_icon_png,

  dgov_icon,
  dgov_icon_png,

  aave_icon,
  aave_icon_png,

  comp_icon,
  comp_icon_png,

  uni_icon,
  uni_icon_png,

  ftm_icon,
  ftm_icon_png,

  floki_icon,
  floki_icon_png,

  yolocoaster_icon,
  yolocoaster_icon_png,

  blur_icon,
  blur_icon_png,

  mong_icon,
  mong_icon_png,

  ladys_icon,
  ladys_icon_png,

  kda_icon,
  kda_icon_png,

  inj_icon,
  inj_icon_png,

  rndr_icon,
  rndr_icon_png,

  tslarekt_icon,
  tslarekt_icon_png,

  yolospy_icon,
  yolospy_icon_png,

  amznrox_icon,
  amznrox_icon_png,

  googlwhale_icon,
  googlwhale_icon_png,

  aaplballer_icon,
  aaplballer_icon_png,

  lina_icon,
  lina_icon_png,

  axs_icon,
  axs_icon_png,

  mana_icon,
  mana_icon_png,

  sand_icon,
  sand_icon_png,

  kmx_icon,
  kmx_icon_png,

  docu_icon,
  docu_icon_png,

  manu_icon,
  manu_icon_png,

  ai_icon,
  ai_icon_png,

  nio_icon,
  nio_icon_png,

  cvna_icon,
  cvna_icon_png,

  afrm_icon,
  afrm_icon_png,

  sofi_icon,
  sofi_icon_png,

  amd_icon,
  amd_icon_png,

  usdt_icon,
  usdt_icon_png,

  pld_icon,
  pld_icon_png,

  eqix_icon,
  eqix_icon_png,

  amt_icon,
  amt_icon_png,

  bch_icon,
  bch_icon_png,

  autogpt_icon,
  autogpt_icon_png,

  wld_icon,
  wld_icon_png,

  xom_icon,
  xom_icon_png,

  pg_icon,
  pg_icon_png,

  unibot_icon,
  unibot_icon_png,

  friend_tech_icon,
  friend_tech_icon_png,

  cart_icon,
  cart_icon_png,

  tia_icon,
  tia_icon_png,

  pyth_icon,
  pyth_icon_png,

  bonk_icon,
  bonk_icon_png,

  meme_icon,
  meme_icon_png,

  gas_icon,
  gas_icon_png,

  wif_icon,
  wif_icon_png,

  sei_icon,
  sei_icon_png,

  cyber_icon,
  cyber_icon_png,

  sui_icon,
  sui_icon_png,

  imx_icon,
  imx_icon_png,

  pendle_icon,
  pendle_icon_png,

  ondo_icon,
  ondo_icon_png,

  manta_icon,
  manta_icon_png,

  cfx_icon,
  cfx_icon_png,

  jup_icon,
  jup_icon_png,

  near_icon,
  near_icon_png,

  tao_icon,
  tao_icon_png,

  pork_icon,
  pork_icon_png,

  dym_icon,
  dym_icon_png,

  zeta_icon,
  zeta_icon_png,

  atom_icon,
  atom_icon_png,

  ntrn_icon,
  ntrn_icon_png,

  bome_icon,
  bome_icon_png,

  vanry_icon,
  vanry_icon_png,

  fil_icon,
  fil_icon_png,

  portal_icon,
  portal_icon_png,

  fet_icon,
  fet_icon_png,

  jasmy_icon,
  jasmy_icon_png,

  agix_icon,
  agix_icon_png,
}
